import script from "./EditorHtmlFieldRichtext.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorHtmlFieldRichtext.vue?vue&type=script&setup=true&lang=js"

import "./EditorHtmlFieldRichtext.vue?vue&type=style&index=0&id=2f56d4f3&lang=css"

const __exports__ = script;

export default __exports__